import React, { useEffect } from 'react';
import './PDPJumpLinks.scss';
import DownArrow from '../../UI/Icons/DownArrow';
import { COLORS } from '../../../constants/colors';

/**
 * Render Jump Links under the PDPHero component
 * @param {Array} links
 */
const PDPJumpLinks = ({ links }) => {
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector(anchor.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
  }, []);

  return (
    <div className="c-pdp-jump-links">
      {links.map((link) => (
        <a className="c-pdp-jump-links__link" href={link.anchor}>
          <img className="c-pdp-jump-links__icon" src={link.icon} alt="" />
          <h4 className="c-pdp-jump-links__heading h3-roobert color-black">{link.text}</h4>
          <DownArrow color={COLORS.black} />
        </a>
      ))}
    </div>
  );
};

export default PDPJumpLinks;
